import React, { Component } from 'react';
import { Button, Form, InputGroup, FormText, FormControl } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import apiFetch from "../utils/apiFetch";

class Settings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            welcome_message: null,
            main_menu_message: null,
            evaluate_message: null,
            result_message: null,
            after_start_message: null,
            wedding_bot_message: null,
            photo_count: 0,
            show_photos_counter: 0,
            ignored_users_links: null
        }
        this.loadSettings()
    }

    loadSettings = () => {
        apiFetch('settings.get').then((result) => {
            this.setState(result.data)
        });
    }

    saveSettings = () => {
        apiFetch('settings.update', this.state).then((result) => {
            console.log(result)
        });
    }

    onChangeInput = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <div className="col-md-5">
                <Form>
                    <h3>Настройки</h3>
                    <Form.Group>
                        <Form.Label>Приветственное сообщение</Form.Label>
                        <Form.Control as="textarea" name="welcome_message" value={this.state.welcome_message} onChange={this.onChangeInput} placeholder="Приветственное сообщение"/>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Сообщение главного меню</Form.Label>
                        <Form.Control as="textarea" name="main_menu_message" value={this.state.main_menu_message} onChange={this.onChangeInput} placeholder="Сообщение главного меню"/>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Сообщение просмотра фото</Form.Label>
                        <Form.Control as="textarea" name="evaluate_message" value={this.state.evaluate_message} onChange={this.onChangeInput} placeholder="Сообщение просмотра фото"/>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Сообщение результата</Form.Label>
                        <Form.Control as="textarea" name="result_message" value={this.state.result_message} onChange={this.onChangeInput} placeholder="Сообщение результата"/>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Сообщение после нажатия начать</Form.Label>
                        <Form.Control as="textarea" name="after_start_message" value={this.state.after_start_message} onChange={this.onChangeInput} placeholder="Сообщение после нажатия начать"/>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Сообщение после нажатия "свадебный бот"</Form.Label>
                        <Form.Control as="textarea" name="wedding_bot_message" value={this.state.wedding_bot_message} onChange={this.onChangeInput} placeholder="Сообщение после нажатия свадебный бот"/>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Количество фото до получения результата</Form.Label>
                        <Form.Control name="photo_count" type="number" value={this.state.photo_count} onChange={this.onChangeInput} placeholder="Количество фото"/>
                    </Form.Group>
                    <Form.Group controlId="formBasicCheckbox">

                        <Form.Check type="checkbox" name="show_photos_counter" label="Показывать ли счётчик просмотренных фото?" checked={this.state.show_photos_counter} onChange={this.onChangeInput}/>
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Пользователи, которых нужно игнорировать в статистике</Form.Label>
                        <Form.Control as="textarea" name="ignored_users_links" value={this.state.ignored_users_links} onChange={this.onChangeInput} placeholder="Пользователи, которых нужно игнорировать в статистике"/>
                    </Form.Group>
                    <Form.Group>
                        <Button onClick={this.saveSettings}>Сохранить</Button>
                    </Form.Group>
                </Form>
            </div>
        );
    }
}

export default withRouter(Settings);







// WEBPACK FOOTER //
// ./src/components/Settings.js